import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import { Button } from '@spotahome/ui-library';
import ListingChipsContainer from '@spotahome/ui-library/src/tenant/components/ListingChipsContainer';
import ListingTitle from '@spotahome/ui-library/src/tenant/components/ListingTitle';
import { formatScheduleRanges } from '@spotahome/ui-library/src/tenant/components/PropertyRulesRedesign/utils';

import { ListingSectionObservable } from '../ListingSection';

import openArrivalKeysSimplifiedModal from './ArrivalKeysSimplifiedModal';

import './ArrivalKeysSimplified.scss';

const ArrivalKeysSimplified = ({ moveInMoveOutPolicy = {} }) => {
  const { moveIn, moveOut } = formatScheduleRanges(
    moveInMoveOutPolicy?.moveInMoveOutSchedules?.ranges
  );

  const hasSchedules = !!moveIn.length || !!moveOut.length;
  const hasAfterHours = !!moveInMoveOutPolicy?.moveInMoveOutSchedules?.price;

  const openModal = () =>
    openArrivalKeysSimplifiedModal({
      moveInMoveOutPolicy,
      hasSchedules,
      hasAfterHours,
      fullscreenOnMobile: true
    });

  const chips = [
    hasSchedules && {
      name: trans(
        'listing.simplification.bottom.arrival-keys.move-in-out-hours.chip'
      ),
      icon: 'clock',
      value: true,
      onClick: openModal
    },
    hasAfterHours && {
      name: trans(
        'listing.simplification.bottom.arrival-keys.after-hours.chip'
      ),
      icon: 'calendar_month',
      value: true,
      onClick: openModal
    },
    {
      name: trans(
        'listing.simplification.bottom.arrival-keys.key-handover.chip'
      ),
      icon: 'key_down',
      value: true,
      onClick: openModal
    }
  ].filter(Boolean);

  return (
    <ListingSectionObservable
      section="arrivalKeys"
      className="arrival-keys-simplified"
    >
      <ListingTitle role="tertiary">
        {trans('listing.simplification.bottom.arrival-keys.card.title')}
      </ListingTitle>
      <ListingChipsContainer
        chipList={chips}
        showShowMoreButton={false}
        className="arrival-keys-simplified__chips"
      />
      <Button
        type="button"
        color="link"
        className="arrival-keys-simplified__learn-more"
        onClick={openModal}
      >
        {trans('listing.simplification.bottom.cancellation.learn-more')}
      </Button>
    </ListingSectionObservable>
  );
};

ArrivalKeysSimplified.propTypes = {
  moveInMoveOutPolicy: PropTypes.shape({
    minimumNoticePeriod: PropTypes.shape({
      days: PropTypes.number,
      price: PropTypes.number
    }),
    moveInMoveOutSchedules: PropTypes.shape({
      price: PropTypes.number,
      ranges: PropTypes.array
    })
  })
};

export default ArrivalKeysSimplified;
